import { Component, OnInit, Input } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'mutara-stepper-header',
  templateUrl: './stepper-header.component.html',
  styleUrls: ['./stepper-header.component.scss'],
  standalone: false
})
export class StepperHeaderComponent extends FieldType implements OnInit {
  @Input() index: number | undefined;
  @Input() stepLabel: string = "Current Step";
  @Input() nextStepLabel: string = "Next Step";
  @Input() canMove: boolean = true;
  @Input() isFixed: boolean = false;
  @Input() stepCount: number | undefined;

  constructor() {
    super();
  }

  ngOnInit(): void {

  }
}